import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "../../store/state/rootReducer";

const selectAuth = (state: RootState) => state.auth;

export const selectAuthenticated = createSelector([selectAuth], (auth) => auth.authenticated);

export const selectRole = createSelector([selectAuth], (auth) => auth.role);
